<template>
  <Modal
    open
    @close="handleCancelButtonClick"
    size="small"
    :hideScrollbar="true"
    :roundedOnMobile="true"
    class="[&_.modal-position]:!px-6"
  >
    <div
      class="relative flex w-full flex-col items-center bg-white text-center sm:rounded-lg"
    >
      <button
        class="absolute right-0 top-0 cursor-pointer text-zinc-600 hover:text-zinc-800"
        @click="handleCancelButtonClick"
      >
        <Icon type="filled" name="close"></Icon>
      </button>
      <div
        class="flex h-full w-full flex-col items-center justify-start gap-y-10"
      >
        <div class="flex h-40 w-full items-center justify-start gap-4">
          <img
            :src="`/uploads/${data.product.primary_image.path}`"
            :key="selectedImage"
            :alt="__('Media image')"
            class="h-40 w-40 rounded-md border border-gray-200 object-cover shadow-md transition-all duration-200 hover:shadow-lg"
          />
          <div class="flex h-full flex-col gap-y-4">
            <div class="flex w-full flex-row items-center justify-start">
              <span class="font-medium text-zinc-600">{{
                data.product.name
              }}</span>
            </div>

            <div
              class="flex w-full flex-row items-center justify-start gap-x-2"
            >
              <span class="text-2xl font-medium">
                {{ data.product.points }}</span
              >
              <Icon name="jobful_points_variant"></Icon>
            </div>
          </div>
        </div>

        <div class="flex w-full flex-col items-center justify-start gap-y-2.5">
          <div class="flex w-full flex-row items-center justify-start gap-x-2">
            <Icon name="group" class="text-primary" type="outlined"></Icon>
            <template v-if="data.product.reviews_data.total_reviews > 0">
              <span class="text-sm text-zinc-600">
                {{ data.product.reviews_data.total_reviews }}
                {{
                  data.product.reviews_data.total_reviews !== 1
                    ? __(' people rated this item')
                    : __(' person rated this item')
                }}
              </span>
            </template>

            <template v-else>
              <span class="text-sm text-zinc-600">{{
                __('Be the first to rate this item!')
              }}</span>
            </template>
          </div>

          <div class="flex w-full flex-row items-center justify-start gap-x-2">
            <span class="font-medium">
              {{ __('How would you rate this item?') }}
            </span>
          </div>

          <div class="flex w-full items-center justify-start gap-x-2 pt-1">
            <span class="font-medium">{{ currentStarValue }}/5</span>
            <div class="flex">
              <Icon
                v-for="i in 5"
                :key="i"
                name="star"
                type="filled"
                :class="
                  i <= (currentStarValue || selectedStarValue)
                    ? 'cursor-pointer text-primary'
                    : 'hover:text-primary-400 cursor-pointer text-zinc-300'
                "
                @mouseover="handleStarHover(i)"
                @mouseleave="handleStarHover(selectedStarValue)"
                @click="handleStarClick(i)"
                size="text-3xl"
              >
              </Icon>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 flex w-full flex-row items-center justify-end gap-2">
        <button
          class="btn btn-outline hover-lift-no-shadow flex w-24 items-center justify-center gap-1.5"
          @click="handleCancelButtonClick"
        >
          <span class="text-primary">{{ __('Cancel') }}</span>
        </button>
        <button
          class="btn btn-fill hover-lift-no-shadow flex w-24 items-center justify-center gap-1.5 disabled:opacity-50"
          type="button"
          @click="$emit('save', { rating: selectedStarValue })"
          :disabled="isLoading"
        >
          <span>{{ __('Save') }}</span>
          <Icon
            v-if="isLoading"
            class="animate-spin text-lg"
            name="progress_activity"
          />
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import Modal from '@/components/block/modal/modal.vue';
  import Icon from '@/components/global/Icon.vue';
  import { __ } from '@/helpers';
  import { ref } from 'vue';
  const props = defineProps({
    data: {
      type: Object,
      required: false
    },
    isLoading: {
      type: Boolean
    }
  });
  const emits = defineEmits(['cancel']);

  const currentStarValue = ref(0);
  const selectedStarValue = ref(0);
  const handleStarHover = (value) => {
    currentStarValue.value = value;
  };

  const handleStarClick = (value) => {
    selectedStarValue.value = value;
  };
  function handleCancelButtonClick() {
    emits('cancel');
  }
</script>
